/**
 * @file   src\pages\SubscriptionListAfterSignup.tsx
 * @brief  Home page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useState, useEffect, useLocation, useSearchParams, Modal, Button, useNavigate, useParams, Link } from "../utils/thirdpartyComponents";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import WashSelection from "src/components/WashSelection";
import axios from '../config/axiosConfig';
import { SubscriptionandwashpriceApi, BayApi } from "../utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";
import { ISubscriptionandsinglewash, ISubscriptionarray, ISingleWasharray, ActiveSubscriptionarray } from '../interfaces/generalInterface';
import { BuyType, EquipmentType, ServiceType, ServiceTypeLabel } from "src/utils/enums";
import { pageURLs } from "src/utils/pageUrls";
import CancelMySubscription from "src/components/CancelMySubscription";
import FullLoader from "src/components/FullLoader";
import SmallLoader from "src/components/SmallLoader";
import SelfServiceWashSelection from "src/components/SelfServiceWashSelection";
import Gobackicon from "../assets/images/left-arrow-small.svg";
import { getBayTypes, getFromLocalStorage } from "src/utils/helper";
import { IBayType } from "src/interfaces/bayinterface";
import { CommonMessages } from 'src/messages/validationMessages';
import { BAY_AVAILABLE, BAY_BUSY, BAY_OUT_OF_SERVICE, BAY_QUEUE } from "../utils/constants";


const SubscriptionListAfterSignup = () => {
  // State to manage if there are no active subscriptions 
  const [inactive, setInactive] = useState(false);


  const navigate = useNavigate()
  // Route information variable
  const params = useParams();

  // Initialise state for list of single wash
  const [showSingleWashTab, setshowSingleWashTab] = useState(false);

  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(false);

  const [showcancelConfirmation, setShowcancelConfirmation] = useState(false);

  // Initialise state for list of subscriptions
  const [subscriptions, setSubscriptions] = useState<ISubscriptionarray[]>([]);

  // Initialise state for list of single wash
  const [singleWash, setSingleWash] = useState<ISingleWasharray[]>([]);
  const [cancelSubscriptionId,setCancelSubscriptionId] = useState(0)
  const [activeUserSubscriptionID,setActiveUserSubscriptionID]  = useState(0)
  const [IsBackButton,setIsBackButton] = useState(false)
  

  const location = useLocation();


  const queryParams = new URLSearchParams(location.search);
  const [tabactiveKey, setTabActiveKey] = useState(() => {
    // Set initial tab based on query parameter
    return queryParams.get('fromTab') === 'singlewash' ? 'singlewash' : 'subscriptions';
  });
  const showSingleWash = queryParams.get('showSingleWash') === 'true';
  const hasQueryParams = location.search !== '';
  const scanAction = (queryParams.get('scan') === 'true') ? true : false;
  const washType = (queryParams.get('washType') === 1 || queryParams.get('washType') === 2) ? queryParams.get('washType') : 0;


  const [searchParams, setSearchParams] = useSearchParams();
  const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(0);
  const [selectedSubscription, setSelectedSubscription] = useState<ISubscriptionarray>();
  const [buyfromtab, setBuyfromtab] = useState('');
  const [updateConfirmationMessage, setupdateConfirmationMessage] = useState('Your subscription will switch to the new plan after your current plan expires. Are you sure you want to change your subscription now?');
  const [activeSubscriptionData, setActiveSubscriptionData] = useState<ActiveSubscriptionarray>();
  const [showTrailPeriodConsumptionModal, setTrailPeriodConsumptionModal] = useState(false);
  const [TrialSubscriptionAvailable, setTrialSubscriptionAvailable] = useState(false);
  const bayType =  location?.state?.bayTypeId
  useEffect(() => {
    if (location.state?.fromScanComplete) {
      setshowSingleWashTab(true);
      setInactive(true);
    }
    if (queryParams.get('showSingleWash') === 'true' && queryParams.get('directpurchase') !== 'true') {
      setshowSingleWashTab(true);
      setInactive(true);
    }

    // Update the active tab if the query parameter changes
    const fromTab = searchParams.get('fromTab');
    if (fromTab === 'singlewash') {
      fetchSingleWashData();
      setTabActiveKey('singlewash');
    } else {
      setTabActiveKey('subscriptions');
    }

  }, [searchParams, location.state]);

  const locationId_from_storage = localStorage.getItem('selectedLocation');
  const locationId = locationId_from_storage ? parseInt(locationId_from_storage, 10) : 0;

  const fetchSubscriptionData = async () => {
    // Instantiate MessageToaster
    const toaster = new MessageToaster();
    setListLoading(true)
    try {
      const requestSubscriptionData: ISubscriptionandsinglewash = {
        typeID: 2,
        locationId: locationId,
        bayType:location?.state?.bayTypeId
      };
      const responseSubscriptions = await axios.post(SubscriptionandwashpriceApi.Subscriptionandwashprice_FETCH, requestSubscriptionData);
      if (responseSubscriptions?.data?.error === 0) {
        setSubscriptions(responseSubscriptions?.data?.data?.subscriptionList);
        if (responseSubscriptions?.data?.data?.activeSubscription?.IsActive)
          setActiveSubscription(responseSubscriptions?.data?.data?.activeSubscription?.SubscriptionID);
          setActiveSubscriptionData(responseSubscriptions?.data?.data?.activeSubscription)
          setActiveUserSubscriptionID(responseSubscriptions?.data?.data?.activeSubscription?.UserSubscriptionID);

          //If already have purchased subscription we will not show trail period data
          const purchasedSubscription = (responseSubscriptions?.data?.data?.purchasedSubscription === 1) ? false : true;
          setTrialSubscriptionAvailable(purchasedSubscription)

      }
      else {
        toaster.toastError(responseSubscriptions?.data?.message);
      }
      setListLoading(false)
    }
    catch (error) {
      throw new Error(error?.response?.data?.message || error?.message);
    }
  };

  const cancelConfirmation = (cancelSubscriptionID:number) =>{
    setShowcancelConfirmation(true)
    setCancelSubscriptionId(cancelSubscriptionID)
  }

  useEffect(() => {
    localStorage.removeItem('subscriptionID')
    fetchSubscriptionData();
    getBayTypes().then((bayTypes: IBayType[]) => {
      if( bayTypes?.length > 1 )
      {
        setIsBackButton(true)                            }
    })

  }, []);

  const fetchSingleWashData = async () => {
    const toaster = new MessageToaster();
    setListLoading(true)
    try {
      const requestSinglewashData: ISubscriptionandsinglewash = {
        typeID: 1,
        locationId: locationId
      };
      const responseSingleWash = await axios.post(SubscriptionandwashpriceApi.Subscriptionandwashprice_FETCH, requestSinglewashData);

      if (responseSingleWash?.data?.error === 0) {
        setSingleWash(responseSingleWash?.data?.data?.subscriptionList);
      }
      else {
        toaster.toastError(responseSingleWash?.data?.message);
      }
      setListLoading(false)
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  //update confirmation modal close function
  const handleOnHide = () => { setShowUpdateConfirmation(false) }

  //buy now click function
  const buynowClick = async (subscription: ISubscriptionarray, buyfrom: string,ServiceType=0) => {
    setBuyfromtab(buyfrom);
    //if active subscription show confrmation modal
    if (activeSubscription && buyfrom === 'subscriptions') {
      if (activeSubscriptionData && activeSubscriptionData?.IsCancelled == 0 && activeSubscriptionData?.numberOfWashes === 0) {
        setupdateConfirmationMessage("Your active subscription has no wash remaining. Your subscription will switch to the new plan. Are you sure you want to change to the new subscription now?")
      } else if (activeSubscriptionData && activeSubscriptionData?.price < subscription.price) {
        setupdateConfirmationMessage("You are upgrading your subscription. Your subscription will switch to the new plan immediately. Are you sure you want to change to the new subscription now?")
      } else if (activeSubscriptionData && activeSubscriptionData?.price > subscription.price) {
        setupdateConfirmationMessage("You are going to downgrade your subscription. Your subscription will switch to the new plan after your current plan expires. Are you sure you want to change your subscription now?")
      }
      setSelectedSubscription(subscription)
      setShowUpdateConfirmation(true)
    }

    else {
      if (subscription.isTrial && TrialSubscriptionAvailable === true) {
        setLoading(true)
        const responseSubscriptions = await axios.get(SubscriptionandwashpriceApi.TRAIL_CONSUMPTION_CHECKING + '/' + subscription.subscriptionID);
        if (responseSubscriptions?.data?.error === 0 && responseSubscriptions?.data?.data?.isConsumed === 1) {
          setLoading(false)
          setSelectedSubscription(subscription)
          setTrailPeriodConsumptionModal(true)
        } else {
          setLoading(false)
          onBuy(subscription, buyfrom,ServiceType);
        }
      } else {
        onBuy(subscription, buyfrom,ServiceType);
      }

    }
  }

  const checkBayStatus = async (bayId: string, washName: string) => {
    const toaster = new MessageToaster();
    try {
      if (!bayId) {
        navigate("/" + params.carwashname + "/" + pageURLs.home);
        return;
      }

      const geo_location = getFromLocalStorage('geolocation');
      const timezoneOffset = (new Date()).getTimezoneOffset();
      if ((geo_location?.lat && geo_location?.long) || scanAction === true) {
        const { data } = await axios.get(BayApi.GET_BAY_STATUS + bayId, {
          params: {
            lat: geo_location?.lat,
            lng: geo_location?.long,
            subType: 1,
            scan: scanAction ? 1 : 0,
            offset: timezoneOffset,
          }
        });
        if (data.error === 0) {
          const hostname = window.location.origin;
          if (data.data.userNearToLocation === false && scanAction === false && !(localStorage.getItem('selectedLocation') == '249' && hostname == 'https://staging-web.carwashapp.com') && !(localStorage.getItem('freeSinglewash') == 'true')) {
            localStorage.removeItem('selectedBay');
            toaster.toastError(data.message);
            navigate("/" + params.carwashname);
          } else if (data.data.bayOpen === false) {
            localStorage.removeItem('selectedBay');
            toaster.toastError(CommonMessages.bay_closed);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
          } else if (data.data.deviceStatus === false) {
            navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
          } else if (data.data.dailyWashLimitReached === true) {
            toaster.toastError(CommonMessages.exp_today_subscription);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
          } else if (data.data.washPackageError === true) {
            toaster.toastError(CommonMessages.washPackageError);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
          } else if (data.data.washCategoryError === true) {
            toaster.toastError(CommonMessages.washCategoryError);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
          } else if (data.data.bayStatus === BAY_AVAILABLE && data.data.paymentStatus === true) {
            navigate("/" + params.carwashname + "/" + pageURLs.statussuccess + "?washType=1", { state: { bayStatusSuccess: true, washName: washName, bayName: data.data.bayName, bayNumber: data.data.bayNumber, bayTypeID: data.data.bayTypeID } });
          } else if (data.data.bayStatus === BAY_QUEUE) {
            navigate("/" + params.carwashname + "/" + pageURLs.scannerque + `?scan=` + scanAction + "&washType=1", { state: { selectedBayId: bayId, washName: washName, bayName: data.data.bayName, bayNumber: data.data.bayNumber, bayTypeID: data.data.bayTypeID } });
          } else if (data.data.bayStatus === BAY_BUSY) {
            navigate("/" + params.carwashname + "/" + pageURLs.statusbusy + `?scan=` + scanAction + "&washType=1", { state: { selectedBayId: bayId, washName: washName, bayName: data.data.bayName, bayNumber: data.data.bayNumber, bayTypeID: data.data.bayTypeID } });
          } else {
            navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
          }
        } else {
          toaster.toastError(data.message);
          navigate("/" + params.carwashname + "/" + pageURLs.home);
        }
      } else {
        toaster.toastError(CommonMessages.no_loc_permission);
        navigate("/" + params.carwashname + "/" + pageURLs.home);
      }
    } catch (error: any) {
      toaster.toastError(error?.response?.data?.message || error?.message);
      navigate("/" + params.carwashname + "/" + pageURLs.home);
    }
  };

  //redirection to payment, or purchase immediately for manager free single wash
  const onBuy = async (subscription: ISubscriptionarray, buyfrom: string, serviceType = 0) => {
    const fromTab = buyfrom;
    const isManagerFreeSingleWash = subscription.subscriptionType === 1 && localStorage.getItem('freeSinglewash') === 'true';

    if (isManagerFreeSingleWash) {
      const toaster = new MessageToaster();
      try {
        setLoading(true);
        const param = {
          planId: subscription.subscriptionID,
          promo_code: '',
          locationId: Number(localStorage.getItem('selectedLocation')),
          promo_code_type: 1,
          payment_mode: 0,
          removeParentLink: false,
          buyupIds: []
        };
        const { data } = await axios.post(SubscriptionandwashpriceApi.PURCHASE_FREE_SINGLE_WASH, param);
        if (data?.error === 0) {
          localStorage.setItem('subscriptionID', String(subscription.subscriptionID));
          const selectedBay = localStorage.getItem('selectedBay') || location?.state?.bayId || '';
          if (selectedBay) {
            if (serviceType === ServiceType.selfServe) {
              navigate("/" + params.carwashname + "/" + pageURLs.selfService, { state: { UserSubscriptionID: data?.data?.userSubscriptionId, bayId: selectedBay } });
            } else {
              await checkBayStatus(String(selectedBay), subscription.washName);
            }
          } else {
            toaster.toastSuccess(data?.message);
            navigate("/" + params.carwashname + "/" + pageURLs.home);
          }
        } else {
          toaster.toastError(data?.message);
        }
      } catch (error: any) {
        toaster.toastError(error?.response?.data?.message || error?.message);
      } finally {
        setLoading(false);
      }
      return;
    }

    if (showSingleWashTab == true && hasQueryParams) {
      navigate("/" + params.carwashname + "/" + pageURLs.payment + "?scan=" + scanAction + "&washType=" + washType, { state: { origin: 'WashSelection_withsingle_wash', fromTab: fromTab, subscriptionID: subscription.subscriptionID, washName: subscription.washName, price: subscription.price, numberOfWashes: subscription.numberOfWashes, subscriptionType: subscription.subscriptionType, bayId: location?.state?.bayId ? location?.state?.bayId : "", isTrial: subscription.isTrial, trialPeriod: subscription.trialPeriod, trialAmount: subscription.trialAmount, TrialSubscriptionAvailable : TrialSubscriptionAvailable, ServiceType:serviceType } })
    }
    else {
      navigate("/" + params.carwashname + "/" + pageURLs.payment + "?scan=" + scanAction + "&washType=" + washType, { state: { origin: 'WashSelection', fromTab: fromTab, subscriptionID: subscription.subscriptionID, washName: subscription.washName, price: subscription.price, numberOfWashes: subscription.numberOfWashes, subscriptionType: subscription.subscriptionType, isTrial: subscription.isTrial, trialPeriod: subscription.trialPeriod, trialAmount: subscription.trialAmount, TrialSubscriptionAvailable : TrialSubscriptionAvailable, ServiceType:serviceType, FamilyDiscount:subscription.FamilyDiscount } })
    }
  };

  //confirm update subscription
  const ConfirmUpdate = async () => {
    if (selectedSubscription) {
      if (selectedSubscription.isTrial) {
        setShowUpdateConfirmation(false)
        setLoading(true)
        const responseSubscriptions = await axios.get(SubscriptionandwashpriceApi.TRAIL_CONSUMPTION_CHECKING + '/' + selectedSubscription.subscriptionID);
        if (responseSubscriptions?.data?.error === 0 && responseSubscriptions?.data?.data?.isConsumed === 1) {
          setLoading(false)
          setTrailPeriodConsumptionModal(true)
        } else {
          setLoading(false)
          onBuy(selectedSubscription, buyfromtab)
        }
      } else {
        onBuy(selectedSubscription, buyfromtab)
      }
    }

  }

  const ConfirmPurchase = () => {
    if (selectedSubscription) {
      selectedSubscription.isTrial = 0;
      selectedSubscription.trialAmount = 0;
      selectedSubscription.trialPeriod = 0;
      onBuy(selectedSubscription, buyfromtab)
    }
  }

  const cartPurchaseModalHide = () => {
    setSelectedSubscription([])
    setTrailPeriodConsumptionModal(false)
  }


  return (
    <div className="common-content-wrap pb-80">
      <div className={inactive ? "inner-content-wrap no-subscription-added" : "inner-content-wrap"}>
        <div className="common-header two-block-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner align-items-center">
            {IsBackButton?
                <div className="common-header-inner">
                    <Link to={"/"+params.carwashname+"/"+pageURLs.selectBayType+'?from=signup'} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link>Buy a {bayType===ServiceType.vacuumWash ? "Vacuum":`Wash-${ServiceTypeLabel[bayType as ServiceType]}`}
                  </div>:
                  <div className="info">
                    <h4 className="pb-0">Buy a {bayType===ServiceType.vacuumWash ? "Vacuum":`Wash-${ServiceTypeLabel[bayType as ServiceType]}`}</h4>
                  </div>}
            </div>
          </div>
        </div>

        {/** This div shown only if there are no active subscriptions.*/}
        <div className={inactive ? "subscription-alert d-block" : "subscription-alert"}>
          <div className="subscription-alert-inner">
            <svg xmlns="http://www.w3.org/2000/svg" width="20.197" height="25.538" viewBox="0 0 20.197 25.538"><g transform="translate(-36.803 -95)"><path d="M.234-.625H10.482a.86.86,0,0,1,.859.859V18.679a.86.86,0,0,1-.859.859H.234a.86.86,0,0,1-.859-.859V.234A.86.86,0,0,1,.234-.625ZM10.091.625H.625V18.288h9.466Z" transform="translate(37.428 101)" fill="#fff" /><path d="M13.641,2.55a2.735,2.735,0,1,1-2.734,2.735A2.738,2.738,0,0,1,13.641,2.55Zm0,4.469a1.735,1.735,0,1,0-1.734-1.735A1.736,1.736,0,0,0,13.641,7.019Z" transform="translate(29.169 100.229)" fill="#fff" /><path d="M5.563.5H0v-1H5.563Z" transform="translate(40.056 110.472)" fill="#fff" /><path d="M3.179.5H0v-1H3.179Z" transform="translate(41.241 112.946)" fill="#fff" /><path d="M15.689,18.295H11.551a1.5,1.5,0,1,1,0-3h4.138a1.5,1.5,0,0,1,0,3Zm-4.138-2a.5.5,0,0,0,0,1h4.138a.5.5,0,0,0,0-1Z" transform="translate(29.221 99.46)" fill="#fff" /><circle cx="8" cy="8" r="8" transform="translate(41 95)" fill="#ffd500" /><path d="M8,2a6,6,0,1,0,6,6A6.007,6.007,0,0,0,8,2M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z" transform="translate(41 95)" fill="#0165bc" /><g transform="translate(47 101)"><line x1="5.657" transform="translate(0 0) rotate(45)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" /><line x1="5.657" transform="translate(0 4) rotate(-45)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" /></g></g></svg>
            <p>You don't have an active subscription.</p>
          </div>
        </div>

        <Tabs
          activeKey={tabactiveKey}
          onSelect={(k) => {
            // Ensure k is a string before setting it as active key
            if (typeof k === 'string') {
              setTabActiveKey(k);
              // Update query parameter based on tab selection
              const searchParams = new URLSearchParams(location.search);
              if (k === 'singlewash') {
                searchParams.set('fromTab', 'singlewash');
              } else {
                searchParams.set('fromTab', 'subscriptions');
              }
              // Update the URL with the new query parameters
              navigate({
                pathname: location.pathname,
                search: searchParams.toString(),
              });
            }
          }}
          id="uncontrolled-tab-example"
          className="buy-wash-tabwrap"
        >
          <Tab eventKey="subscriptions" title="Subscriptions">
            {listLoading ? <SmallLoader /> : bayType == 0 ? subscriptions && subscriptions.length ?
              subscriptions.map((subscription, index) => (

                <WashSelection
                  key={index}
                  SubscriptionID={subscription.subscriptionID}
                  WashName={subscription.washName}
                  SubscriptionDetails={subscription.subscriptionDetails}
                  Price={subscription.price}
                  NumberOfWashes={subscription.numberOfWashes}
                  dailyWashLimit={subscription.dailyWashLimit}
                  show_single_wash={showSingleWashTab}
                  buyType={BuyType.SUBSCRIPTION}
                  hasActiveSubscription={activeSubscription}
                  setShowUpdateConfirmation={setShowUpdateConfirmation}
                  subscription={subscription}
                  onBuynowClick={(subscription: ISubscriptionarray) => buynowClick(subscription, 'subscriptions',ServiceType.bayTunnel)}
                  setShowcancelConfirmation={(flag: boolean) => setShowcancelConfirmation(flag)}
                  subscriptionType={subscription.subscriptionType}
                  TrialSubscriptionAvailable = {TrialSubscriptionAvailable}
                  activeUserSubscriptionID= {activeUserSubscriptionID}
                  HasVacuumWash={subscription.HasVacuumWash}
                  NumberOfVacuumWashes={subscription.NumberOfVacuumWashes}
                  MaxVacuumTime={subscription.MaxVacuumTime}
                  IsUnlimitedWash={subscription.IsUnlimitedWash}
                  FamilyDiscount={subscription.FamilyDiscount}
                  HasFreeSelfServe={subscription.HasSelfService}
                  NumberOfFreeSelfWashes={subscription.NumberOfSelfServices}
                  MaxSelfServiceTime={subscription.MaxSelfServiceTime}
                />
              ))
              : (
                <tr>
                  <p>No data found</p>
                </tr>
              )
            
            :
subscriptions?.length ? (
        subscriptions.map((subscription) => {
          const commonProps = {
            // key: index,
            SubscriptionID: subscription.subscriptionID,
            WashName: subscription.washName,
            SubscriptionDetails: subscription.subscriptionDetails,
            Price: subscription.price,
            NumberOfWashes: subscription.numberOfWashes,
            dailyWashLimit: subscription.dailyWashLimit,
            show_single_wash: showSingleWashTab,
            buyType: BuyType.SUBSCRIPTION,
            hasActiveSubscription: activeSubscription,
            setShowUpdateConfirmation,
            subscription,
            onBuynowClick: (subscription: ISubscriptionarray) =>
              buynowClick(subscription, 'subscriptions',ServiceType.selfServe),
            cancelConfirmation: (id: number) =>
              cancelConfirmation(id),
            subscriptionType: subscription.subscriptionType,
            TrialSubscriptionAvailable,
            // coords,
            // isGeolocationAvailable,
            // isGeolocationEnabled,
            WashTime:subscription.WashTime,
            activeUserSubscriptionID:activeUserSubscriptionID,
            HasVacuumWash:subscription.HasVacuumWash,
            NumberOfVacuumWashes:subscription.NumberOfVacuumWashes,
            MaxVacuumTime:subscription.MaxVacuumTime,
            FamilyDiscount:subscription.FamilyDiscount
          };
          return <SelfServiceWashSelection key={ subscription.subscriptionID} {...commonProps} />
          // return bayTypeId === 0
          //   // ? <WashSelection key={ subscription.subscriptionID} {...commonProps} />
          //   : <SelfServiceWashSelection key={ subscription.subscriptionID} {...commonProps} />;
        })
      ) : (
        <tr>
          <p>No data found</p>
        </tr>
      )}
          </Tab>
          {showSingleWash && (
            <Tab eventKey="singlewash" title="Single Wash" onEnter={fetchSingleWashData}>
              {listLoading ? <SmallLoader /> :
                singleWash && singleWash.length > 0 ? singleWash.map((wash, index) => (

                  <WashSelection
                    key={index}
                    SubscriptionID={wash.subscriptionID}
                    WashName={wash.washName}
                    SubscriptionDetails={wash.subscriptionDetails}
                    Price={wash.price}
                    show_single_wash={showSingleWashTab}
                    buyType={BuyType.SINGLE_WASH}
                    subscription={wash}
                    onBuynowClick={(subscription: ISubscriptionarray) => buynowClick(subscription, 'singlewash',ServiceType.bayTunnel)}
                    setShowcancelConfirmation={(flag: boolean) => setShowcancelConfirmation(flag)}
                    subscriptionType={wash.subscriptionType}
                  />
                ))
                  : (
                    <tr>
                      <p>No data found</p>
                    </tr>
                  )

              }
            </Tab>
          )}
        </Tabs>
      </div>
      
        <div className="footer-wrap">
            <ul className="footer-inner-wrap">
                <li className="w-100 skip-link">
                    <Link to={"/" + params.carwashname + "/" + pageURLs.home}title="Skip to Home" className="d-flex align-items-center flex-row">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24.808" height="20.565" viewBox="0 0 24.808 20.565"><g transform="translate(0.037 0.064)"><g transform="translate(0 0)"><path d="M13.4,7.794a1.364,1.364,0,1,1-1.365,1.364A1.364,1.364,0,0,1,13.4,7.794" transform="translate(-1.031 -0.668)" fill="#fff" /><path d="M13.763,7.044a2.478,2.478,0,1,1-2.48,2.479A2.481,2.481,0,0,1,13.763,7.044Zm0,3.456a.978.978,0,1,0-.98-.978A.979.979,0,0,0,13.763,10.5Z" transform="translate(-1.395 -1.032)" fill="#515151" /><path d="M21.026,20.565H15.971a.75.75,0,0,1-.747-.683l-.309-3.463h-4.63l-.259,3.453a.75.75,0,0,1-.748.694H4.4a.75.75,0,0,1-.75-.75V6.891a.75.75,0,0,1,.306-.6L12.3.146a.75.75,0,0,1,.891,0l8.278,6.141a.75.75,0,0,1,.3.6V19.815A.75.75,0,0,1,21.026,20.565Zm-4.369-1.5h3.619V7.268l-7.53-5.586L5.148,7.27V19.065H8.583l.259-3.453a.75.75,0,0,1,.748-.694H15.6a.75.75,0,0,1,.747.683Z" transform="translate(-0.377 -0.064)" fill="#515151" /><path d="M.438,4.49-.438,3.272,4.96-.609,5.836.609Z" transform="translate(0.401 5.549)" fill="#515151" /><path d="M4.96,4.49-.438.609.438-.609l5.4,3.881Z" transform="translate(18.935 5.549)" fill="#515151" /></g></g></svg>
                      Skip to Home
                    </Link>
                </li>
            </ul>
        </div >
    
      {/* signout confirmation Modal */}
      <Modal
        show={showUpdateConfirmation}
        onHide={handleOnHide}
        centered
        className='notification-modal'
      >
        {/* Update subscription confirmation modal */}
        <Modal.Body className='text-center'>
          <h6>{updateConfirmationMessage}
          </h6>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className="m-0" onClick={handleOnHide}>No</Button>
          <Button variant="primary" className='primary-btn btn-main m-0' onClick={ConfirmUpdate}>Yes</Button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={showTrailPeriodConsumptionModal}
        onHide={cartPurchaseModalHide}
        centered
        className='notification-modal'
      >
        <Modal.Body className='text-center'>
          <h6>You have already used the trial period, so the normal rates will apply. Do you want to continue?</h6>
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className="m-0" onClick={cartPurchaseModalHide}>Cancel</Button>
          <Button variant="primary" className='primary-btn btn-main m-0' onClick={ConfirmPurchase}>Continue</Button>
        </Modal.Footer>
      </Modal>
      <CancelMySubscription
         setShowcancelConfirmation={(flag:boolean)=>setShowcancelConfirmation(flag)}
         cancelConfirmation={(id: number) => cancelConfirmation(id)}
        setLoading={(flag: boolean) => setLoading(flag)}
        showcancelConfirmation={showcancelConfirmation}
        from={'purchase'}
        cancelSubscriptionID = {cancelSubscriptionId}
      // from={pageURLs.subscriptionandwashprice}
      />
      {loading ? <FullLoader /> : ""}
    </div>
  )
};

export default SubscriptionListAfterSignup;
